<template>
  <div :class="classes" ref="card">
    <slot />
  </div>
</template>

<script>
import classnames from 'classnames';

export default {
  name: 'Card',
  props: {
    padding: {
      type: String,
      default: '15px',
    },
    shadow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
      classes() {
        return classnames('card', {
          "card__shadow": this.shadow
        });
    },
  },
  mounted() {
    this.$refs.card.style.padding = this.padding;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Card.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Card/Card.vue